import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  Modal,
  HelperViewContextual,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { EBlockTypes } from '@/modules/catalog/types/block-types';

interface Props {
  isOpen: boolean;
  type: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BlockedInvestmentModal',
  props: {
    isOpen: { type: Boolean },
    type: null
  },
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  type: string;
};

const router = useRouter();



const helperData = computed(() => {
  if (props.type === EBlockTypes.REGULATORY_UPDATE) {
    return {
      title: 'Atualize seu cadastro',
      description:
        'Não é possível investir quando há uma atualização cadastral pendente.'
    };
  }

  return {
    title: 'Perfil incompatível',
    description:
      'Não é possível investir no produto, pois ele possui um público alvo que não se enquadra no seu perfil de investidor.'
  };
});

const listValue = computed(() => {
  const mapper: { [key: string]: string } = {
    [EBlockTypes.QUALIFIED_INVESTOR]: 'Investidor qualificado',
    [EBlockTypes.PROFESSIONAL_INVESTOR]: 'Investidor profissional'
  };

  return mapper[props.type];
});

function goToRegulatoryUpdate() {
  router.push({ name: 'regulatoryUpdateAnnouncement' });
}

return { __sfc: true,router, props, helperData, listValue, goToRegulatoryUpdate, Modal, HelperViewContextual, ListDisplay, ButtonContainer, ButtonPrimary, EBlockTypes }
}

})